import {IStatistics} from '@app/core/services/api/statistic.service';
import {ISalaryPercentageModel} from '@app/core/models/salary-percentage-live.model';
import {ISalaryExpenseStatisticsModel} from '@app/core/models/salary-expense-statistics.model';
import * as moment from 'moment';
import {Moment} from 'moment';
import {IRevenueStatisticsModel} from '@app/core/models/statistics-revenue.model';
import {IQODateRange} from '@quickorder/angular-web-lib';

export interface IStatisticsState {
	statistics: IStatistics;
	isLoading: boolean;
	salaryPercentage: ISalaryPercentageModel[];
	salaryExpenses: ISalaryExpenseStatisticsModel[];
	revenue: IRevenueStatisticsModel[];
	dateRange: IQODateRange<Moment>;
}

export const initialStatisticsState: IStatisticsState = {
	statistics: undefined,
	isLoading: false,
	salaryPercentage: [],
	salaryExpenses: [],
	revenue: [],
	dateRange: {begin: moment().subtract(7, 'days'), end: moment()},
};
